import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

export default class ChatBackArrow extends Component {
  render () {
    return (
      <button className='chat-back-arrow' onClick={this.props.onClick}>
        <FontAwesomeIcon icon={faArrowLeft} />
      </button>
    );
  }
}

ChatBackArrow.propTypes = {
  onClick: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/common/ui/QuickView/ChatBackArrow.js